import React from 'react'
import PaperPage from 'src/components/organisms/whitepapers/PaperPage'
import thumbnail from 'src/images/whitepapers/commmune_fanmarketing.jpg'

const paperInfo = {
    paperName: 'ロイヤルユーザーを増やすには...\n知っておきたいファンマーケティングとは？',
    thumbnail,
    feature1: '従来のマーケティングとの違い',
    feature2: 'ファンマーケティングの重要性',
    feature3: 'ファンマーケティングの手法',
    description:
        '近年「ファンマーケティング」が注目されています。ファンマーケティングとは、商品やブランド・その企業に対して強い愛着を持った「ファン」を増やしていくことで、中長期的な売上の拡大を狙うマーケティング手法です。この資料を読むことで、ファンマーケティングが重要視されている理由や、具体的な施策について理解が深まります。',
    formSrc: 'https://go.commmune.jp/l/915341/2022-07-20/hqfcl',
    type: 'pardot' // TODO: HubSpotからPardotに移行したらこのタグ付けが不要になるので削除する
}

const WhitePaperPage = () => {
  return <PaperPage {...paperInfo} />
}

export default WhitePaperPage
